import React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function TaskLoadingSkeleton() {
  return (
    <>
      <Skeleton
        animation="wave"
        variant="text"
        sx={{ fontSize: "1rem" }}
        height={60}
        width={450}
      />
      <Skeleton animation="wave" variant="rectangular" height="50vh" />
    </>
  );
}
